import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const config = {
    apiUri: window.configBC.apiUri || process.env.VUE_APP_API_URI,
    adminUri: window.configBC.adminUri || process.env.VUE_APP_ADMIN_URI,
    adminOrderCreate: window.configBC.adminOrderCreate || process.env.VUE_APP_ADMIN_URI,
    wsUri: window.configBC.wsUri || process.env.VUE_APP_WS_URI,
    wsAppId: window.configBC.wsAppId || process.env.VUE_APP_WS_APPID,
    lang: window.configBC.lang || process.env.VUE_APP_LANG,
    apiToken: window.configBC.apiToken || process.env.VUE_APP_API_TOKEN
}

axios.defaults.baseURL = config.apiUri
axios.defaults.headers.common['Authorization'] = `Jwt ${config.apiToken}`

/* global $ */
Vue.use(Vuex)

export const store = new Vuex.Store({
    state() {
        return {
            orderDetails: {},
            orderList: [],
            changeOrderOpen: false,
            loading: true,
            loadingLabel: 'loading.orderDetails',
            error: 'connectionError',
            config
        }
    },

    plugins: [createPersistedState()],

    mutations: {
        updateOrderDetails(state, payload) {
            state.orderDetails = payload
        },

        updateOrderList(state, payload) {
            state.orderList = payload
        },

        //  TOGGLES
        toggleSelectActivableOrder(state, payload) {
            state.changeOrderOpen = payload
        },

        toggleLoading(state, payload) {
            state.loading = payload
        },

        //  LABELS UPDATE
        updateLoadingLabel(state, payload) {
            state.loadingLabel = payload
        },

        updateError(state, payload) {
            state.error = payload
        },
    },

    getters: {
        isActiveOrder: state => {
            return state.orderDetails.id
        }
    },

    actions: {
        showError: (context, payload) => {
            context.commit('toggleLoading', false)
            context.commit('updateError', payload)
            $(".modal-error").modal("show");
        },

        //  GET Active order details
        fetchActiveOrder: (context) => {
            context.commit('updateLoadingLabel', 'orderDetails')

            axios.get('/orders/active').then(res => {
                let data = res.data
                context.commit('updateOrderDetails', data)
                context.commit('toggleSelectActivableOrder', false)
                context.commit('toggleLoading', false)
            }).catch(() => {
                context.dispatch('showError', 'getActiveOrderDetails')
            })
        },

        //  GET Activable orders list
        fetchActivableOrders: (context) => {
            axios.get('/orders').then(res => {
                context.commit('updateOrderList', res.data)
            })
        },

        //  POST Activate order 
        activeSelectedOrder: (context, payload) => {
            $(".modal-id").modal("hide");
            context.commit('updateLoadingLabel', 'changeActiveOrder')
            context.commit('toggleLoading', true)

            axios.post(`/orders/activate/${payload}`)
                .catch(() => {
                    context.dispatch('showError', 'changeActiveOrder')
                })
        },

        //  DELETE Remove article
        removeProduct: (context, payload) => {
            return axios.delete(`/orders/active/items/${payload}`).catch(() => {
                context.dispatch('showError', 'removeProduct')
            })
        },
    }
})